import { ICartBox, IChild, IOrderBox } from '@interfaces';

import ImgPersonalizedBox from '@img/boxes/personalized-box.jpg';
import ImgCustomBox from '@img/boxes/custom-box.jpg';
import { WPImage } from '@v2/utils/image';
import BoxEntity from '@v2/entities/box.entity';

export function BoxImage({box}: {box: IChild}) {
    const source = (box && box.properties && box.image)
                    ?  box.image
                    : (box.isChild &&  box.recommendedPacksEnabled)
                        ? ImgPersonalizedBox
                        : ImgCustomBox;
    return (
        <img src={source} alt={box.name}/>
    )
}

export function CartBoxImage({box}: {box: ICartBox}) {
    const source = (box && box.image)
                    ? box.image
                    : (box.child && box.child.recommendedPacksEnabled)
                        ? ImgPersonalizedBox
                        : ImgCustomBox;
    return (
        <WPImage src={source} alt={box.title}/>
    )
}

export function OrderBoxImage({box}: {box: IOrderBox}) {
    const source = (box && box.image)
                    ? box.image
                    : box.type === 'personalized'
                        ? ImgPersonalizedBox
                        : ImgCustomBox;
    return (
        <img src={source} alt={box.name} loading="lazy"/>
    )
}

export function BoxEntityImage({box}: {box: BoxEntity}) {
    const source = (box && box.image)
                    ? box.image
                    : box.type === 'personalized'
                        ? ImgPersonalizedBox
                        : ImgCustomBox;
    return (
        <img src={source} alt={box.title} loading="lazy"/>
    )
}